// extracted by mini-css-extract-plugin
module.exports = {"homeWrap":"home_homeWrap__2g-Sw","headButtonWrap":"home_headButtonWrap__N5Z7w","headButtonItem":"home_headButtonItem__1oEl4","contentWrap":"home_contentWrap__Gxw_C"};